/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Helmet } from "react-helmet";
import { CheckSquare, Square, Bell, Paperclip } from "react-feather";
import DataTable, { createTheme } from "react-data-table-component";
import SweetAlert from "sweetalert2";
import { Button, Tooltip, Form } from "reactstrap";
import { toast } from "react-toastify";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import { StyledSelect } from "../../components/StyledSelect";
import useFetcher from "../../hooks/useFetcher";
import usePaging from "../../hooks/usePaging";
import { fetchSubclientsPaginados, patchCalendar, fetchClient, fetchDeliverDateCategorias } from "../../services/subclientesServices";
import { fetchCasasCentrales } from "../../services/casaCentralServices";
import { fetchSucursales } from "../../services/sucursalServices";
import { fetchRegiones } from "../../services/regionServices";
import { fetchServicios } from "../../services/servicioServices";
import { fetchCompanias } from "../../services/companiaServices";
import { retriveRegionSucursalOptions } from "../../utils/retriveRegionSucursalOptions";
import ModalSubclients from "./ModalSubclients";
import { handleErrors } from "../../services/handleErrors";
import SubclientInfo from "./SubclientInfo";
import Centralizador from "./Centralizador";
import ModalAlertas from "../../components/Alertas";
import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";
import { subclienteUtil } from "../../utils/subclienteUtil";
import { useFiles } from "../../hooks/useFiles";
import { showFile, patchFile, uploadFiles } from "../../services/fileServices";
import { LabSelect } from "../../components/course/select";
import { CustomLabel } from "../../ui/labels";
import { tableCustomStyles } from "../../ui/table";
import { ButtonPrimary } from "../../ui/buttons";

const Subclientes = ({ location, history }) => {
  const { currentUser } = useAuth();
  const [subclientesModal, setSubclientesModal] = useState(false);
  const [subclientId, setSubclientId] = useState("");
  const [subclienteUtilSelected, setSubclienteUtilSelected] = useState(null);
  const [servicioSelected, setServicioSelected] = useState({ label: "", value: "" });
  const [companiaSelected, setCompaniaSelected] = useState({ label: "", value: "" });
  const pagingController = usePaging(fetchSubclientsPaginados);
  const [casasCentrales, isLoadingCasasCentrales] = useFetcher(fetchCasasCentrales, undefined, "fetchCasasCentrales");
  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones, undefined, "fetchRegiones");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [servicios, isLoadingServicios] = useFetcher(fetchServicios, undefined, "fetchServicios");
  const [companias, isLoadingCompanias] = useFetcher(fetchCompanias, undefined, "fetchCompanias");
  const [fechaEntregaOptions, isLoadingFechaEntregaOptions] = useFetcher(fetchDeliverDateCategorias);
  const [newSubclient, setNewSubclient] = useState(false);
  const [titleRazonSocial, setTitleRazonSocial] = useState("");
  const [clientId, setClientId] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [fileId, setFileId] = useState(false);
  const [isUploadingFiles, handleUploadFileButton, handleConfirmSelectedFiles] = useFiles();
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const [imageUrl, setImageUrl] = useState(null);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.CLIENTES);
  const isAudit = currentUser && currentUser.haveAuditAccess(modulos.CLIENTES);
  const helperRegionSucursal = retriveRegionSucursalOptions(
    pagingController.query.region,
    pagingController.query.sucursal,
    regiones,
    sucursales,
    casasCentrales,
    isLoadingRegiones || isLoadingSucursales || isLoadingCasasCentrales
  );

  const uploadOrPatchFiles = async () => {
    setIsLoadingFiles(true);
    const selectedFiles = document.getElementById("upfile").files;
    const file =
      fileId !== false
        ? await patchFile({ entity: "client", entityId: clientId, fileId, files: selectedFiles })
        : await uploadFiles({ entity: "client", entityId: clientId, files: selectedFiles });
    setFileId(file.result.id);
    const image = await showFile({ entity: "client", entityId: clientId, fileId: file.result.id });
    setImageUrl(image.href);
    setIsLoadingFiles(false);
    setIsLoadingFiles(false);
  };

  const serviciosOptions = servicios.map((servicio) => {
    return { label: servicio.text, value: servicio.id };
  });

  const companiasOptions = companias.map((compania) => {
    return { label: compania.text, value: compania.id };
  });

  const filterValue = (value) => {
    pagingController.setFilterValue(value);
  };

  const handleReactSelectChange = (selected, options) => {
    const newState = { [options.name]: selected ? selected.value : null };
    filterValue(newState);
  };

  const handleServicioChange = (selected, options) => {
    const newState = { [options.name]: selected ? selected.value : null, razonSocial: null };
    filterValue(newState);
    setServicioSelected(selected);
  };

  const handleCompaniaChange = (selected, options) => {
    const newState = { compañia: selected ? selected.value : null };
    filterValue(newState);
    setCompaniaSelected(selected);
  };

  const handleRowClicked = (row) => {
    setSubclientesModal(true);
    setSubclientId(row.itemId);
    setSubclienteUtilSelected(subclienteUtil(row));
  };

  const reloadTable = () => {
    setTimeout(() => {
      pagingController.reloadData(history.location);
    }, 1000);
  };

  const updateCalendarStatus = async (body, row) => {
    try {
      await patchCalendar(body);
      toast.success("El subcliente se actualizó correctamente");
      reloadTable(history.location);
    } catch (error) {
      handleErrors(error);
      toast.error("El subcliente no se pudo actualizar.");
    }
  };

  const handleCalendarCheck = async (row) => {
    if (!isAdmin) {
      return;
    }

    const { isConfirmed } = await SweetAlert.fire({
      title: `${!row.calendar ? "El subcliente seleccionado va a calendarizarse" : "El subcliente seleccionado dejará de calendarizarse"}`,
      icon: "warning",
      confirmButtonColor: "#bf0d3e",
      showCancelButton: true,
      showConfirmButton: true,
    });

    if (isConfirmed) {
      const body = {
        calendar: !row.calendar,
        numeroDeLegajo: row.numeroDeLegajo,
      };
      updateCalendarStatus(body, row);
    }
  };
  const handleAlert = (row) => {
    setSubclientId(row.itemId);
    setSubclienteUtilSelected(subclienteUtil(row));
    setShowAlert(true);
  };

  const handleToggleSubclientModal = () => {
    setNewSubclient(!newSubclient);
    pagingController.reloadData(history.location);
  };

  useEffect(async () => {
    if (pagingController) {
      const id = pagingController.query.clientId;
      const client = await fetchClient(id);
      setIsLoadingFiles(true);
      if (client.Files[0]) {
        const image = await showFile({ entity: "client", entityId: id, fileId: client.Files[0].id });
        setImageUrl(image.href);
        setFileId(client.Files[0].id);
        setIsLoadingFiles(false);
      }
      setTitleRazonSocial(client.razonSocial);
      setClientId(id);
    }
  }, [pagingController && pagingController.query && pagingController.query.clientId]);

  const deliverDateOptions =
    fechaEntregaOptions.entregaFC && fechaEntregaOptions.entregaFC.type
      ? fechaEntregaOptions.entregaFC.type.map((option) => {
          return { label: option.text, value: option.id };
        })
      : [];

  const showDeliverDateLabel = (selected) => {
    const option = deliverDateOptions.filter((opt) => {
      if (opt.value === selected) {
        return opt.label;
      }
      return null;
    });
    return option && option[0];
  };

  const ClientIdNumber = pagingController.query.clientId;

  useEffect(() => {
    if (history && companiasOptions.length > 0 && servicios.length > 0) {
      const params = new URLSearchParams(history.location.search);
      const servicio = params.get("servicio");
      const compañia = params.get("compañia");
      const serviceFounded = servicios.find((serv) => serv.id == servicio);
      if (serviceFounded) {
        setServicioSelected({ label: serviceFounded.text, value: serviceFounded.id });
      } else {
        setServicioSelected({ label: "", value: "" });
      }
      const companiaFounded = companiasOptions.find((com) => com.value == compañia);
      if (companiaFounded) {
        setCompaniaSelected({ label: companiaFounded.label, value: companiaFounded.value });
      } else {
        setCompaniaSelected({ label: "", value: "" });
      }
    }
  }, [history, pagingController.isLoading]);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1650);
    };

    window.addEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {subclientesModal ? (
        <ModalSubclients
          toggle={() => {
            history.push(`/subclientes${location.search}`);
            setSubclientesModal(!subclientesModal);
          }}
          subclientId={subclientId}
          razonSocial={titleRazonSocial}
          editModal={() => setSubclientesModal(!subclientesModal)}
          subclienteUtil={subclienteUtilSelected}
          ClientId={clientId}
        />
      ) : null}
      {newSubclient ? <SubclientInfo toggle={handleToggleSubclientModal} razonSocial={titleRazonSocial} ClientId={ClientIdNumber} /> : null}
      {showAlert ? (
        <ModalAlertas
          toggle={() => {
            setShowAlert(!showAlert);
            pagingController.reloadData(history.location);
          }}
          subclientId={subclientId}
          subclienteUtil={subclienteUtilSelected}
        />
      ) : null}
      <Helmet>
        <title>{`PIN - ${titleRazonSocial}`}</title>
      </Helmet>
      <div className="d-flex w-100 align-items-center content-space-between pr-3">
        <Breadcrumb title={titleRazonSocial} parent="Sistema de clientes" backButton />
        <div className="d-flex align-items-center justify-content-center" style={{ position: "fixed", right: "20px" }}>
          <Tooltip
            isOpen={tooltipOpen}
            toggle={toggle}
            placement="bottom"
            target="imagenCliente"
            style={{ color: "white", background: "#da291c ", marginRight: "3px", cursor: "pointer" }}
          >
            Agregar/Modificar imagen del Cliente
          </Tooltip>

          <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
            <input id="upfile" type="file" onChange={() => uploadOrPatchFiles({ entity: "client", entityId: ClientIdNumber, fileId })} accept="image/jpeg,image/png" />
          </Form>
          <div className="d-flex align-items-center justify-content-center  flex-wrap mb-1">
            {imageUrl !== null ? (
              <BlurSpinner isLoading={isLoadingFiles}>
                <div className="d-flex align-items-center  ">
                  <img
                    src={imageUrl}
                    alt="imgClient"
                    style={{
                      maxHeight: "80px",
                      zIndex: "1",
                      opacity: "1",
                      marginRight: "0px",
                      maxWidth: isMobile ? "150px" : "280px",
                    }}
                  />
                </div>
              </BlurSpinner>
            ) : null}
            <Button className="btn btn-link" type="button" color="link" onClick={handleUploadFileButton} disabled={isAudit}>
              <Paperclip
                id="imagenCliente"
                color={isAudit ? "#cccccc" : "#da291c"}
                style={{ marginRight: "20px", marginLeft: "10px", cursor: "pointer" }}
                onClick={handleUploadFileButton}
              />
            </Button>
          </div>
          <ButtonPrimary
            className="btn mb-1"
            style={{ textAlign: "center", height: "50px" }}
            onClick={() => {
              history.push(`/infoGeneral?clientId=${clientId}`);
            }}
          >
            Informacion General
          </ButtonPrimary>
        </div>
      </div>
      <BlurSpinner isLoading={pagingController.isLoading || isLoadingSucursales}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3 col-12">
                      <div className="form-group">
                        <CustomLabel htmlFor="region" className="col-form-label pt-0 w-100">
                          Región
                        </CustomLabel>
                        <LabSelect
                          id="region"
                          name="region"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={
                            helperRegionSucursal.regionesOptions.find((option) => {
                              return option.value === helperRegionSucursal.selectedRegion;
                            }) || null
                          }
                          placeholder="Todo"
                          isClearable
                          isLoading={helperRegionSucursal.isLoadingRegiones}
                          options={helperRegionSucursal.regionesOptions}
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <CustomLabel htmlFor="sucursal" className="col-form-label pt-0 w-100">
                          Sucursal
                        </CustomLabel>
                        <LabSelect
                          id="sucursal"
                          name="sucursal"
                          className="w-100"
                          onChange={handleReactSelectChange}
                          value={
                            helperRegionSucursal.casasAndSucusOptions.find((option) => {
                              return option.value === helperRegionSucursal.selectedSucursal;
                            }) || null
                          }
                          placeholder="Todo"
                          isClearable
                          isLoading={helperRegionSucursal.isLoadingSucursales}
                          options={helperRegionSucursal.casasAndSucusOptions}
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <CustomLabel htmlFor="servicio" className="col-form-label pt-0 w-100">
                          Servicio
                        </CustomLabel>
                        <LabSelect
                          id="servicio"
                          name="servicio"
                          className="w-100"
                          onChange={handleServicioChange}
                          value={
                            (servicioSelected &&
                              serviciosOptions.find((option) => {
                                return option.value === servicioSelected.value;
                              })) ||
                            null
                          }
                          placeholder="Todo"
                          isClearable
                          isLoading={isLoadingServicios}
                          options={serviciosOptions}
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <CustomLabel htmlFor="servicio" className="col-form-label pt-0 w-100">
                          Compañia
                        </CustomLabel>
                        <LabSelect
                          id="compania"
                          name="compania"
                          className="w-100"
                          onChange={handleCompaniaChange}
                          value={
                            (companiaSelected &&
                              companiasOptions.find((option) => {
                                return option.value === companiaSelected.value;
                              })) ||
                            null
                          }
                          placeholder="Todo"
                          isClearable
                          isLoading={isLoadingCompanias}
                          options={companiasOptions}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <div style={{ display: "flex", justifyContent: "right", paddingRight: "45px" }}>
                    {isAdmin && (
                      <Button className="sm btn btn-primary" onClick={() => setNewSubclient(!newSubclient)}>
                        Nuevo Subcliente
                      </Button>
                    )}
                  </div> */}
                  <div className="table-responsive support-table">
                    <DataTable
                      title="Subclientes"
                      paginationComponentOptions={{ rowsPerPageText: "Subclientes por pagina", rangeSeparatorText: "De" }}
                      noDataComponent={
                        <div className="p-3">
                          <b>No se encontraron Subclientes</b>
                        </div>
                      }
                      striped
                      pagination
                      sortServer
                      paginationServer
                      onRowClicked={handleRowClicked}
                      data={pagingController.data}
                      onSort={pagingController.handleSortsChange}
                      paginationTotalRows={pagingController.totalRows}
                      paginationDefaultPage={parseInt(pagingController.query.page || 1, 10)}
                      onChangeRowsPerPage={pagingController.handleRecordsPerPageChange}
                      paginationPerPage={parseInt(pagingController.query.perpage || 10, 10)}
                      onChangePage={pagingController.handlePageChange}
                      customStyles={tableCustomStyles}
                      columns={[
                        {
                          name: "Subcliente",
                          selector: (row) => row.numeroDeLegajo.replace(".0000", "").padStart(7, 0) || "-",
                          sortable: true,
                          center: true,
                          id: "subcliente",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                        },
                        {
                          name: "Sucursal",
                          selector: (row) => (row.Sucursal && row.Sucursal.titulo) || "-",
                          sortable: false,
                          center: true,
                          id: "sucursal",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                        },
                        {
                          name: "Servicio",
                          selector: (row) => (row.servicio2Cat ? row.servicio2Cat.text : "-"),
                          sortable: true,
                          center: true,
                          id: "servicio",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                        },
                        {
                          name: "Compañia",
                          selector: (row) => (row.companiaCat ? row.companiaCat.text : "-"),
                          sortable: true,
                          center: true,
                          id: "compania",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                        },
                        {
                          name: "Fecha de entrega",
                          selector: (row) => (showDeliverDateLabel(row.fechaDeEntrega) && showDeliverDateLabel(row.fechaDeEntrega).label) || "-",
                          sortable: true,
                          center: true,
                          id: "fechaEntrega",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                        },
                        {
                          name: "Centralizador",
                          cell: (row) => <Centralizador row={row} reloadTable={() => reloadTable()} />,
                          sortable: false,
                          center: true,
                          id: "centralizador",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                            width: "220px",
                            padding: "0",
                            paddingLeft: "32px",
                          },
                        },
                        {
                          name: "Calendario",
                          selector: (row) => (
                            <div>
                              {row.calendar ? (
                                <span className="action-box complete-btn">
                                  <CheckSquare color="red" onClick={() => handleCalendarCheck(row)} />
                                </span>
                              ) : (
                                <span className="action-box complete-btn">
                                  <Square onClick={() => handleCalendarCheck(row)} />
                                </span>
                              )}
                            </div>
                          ),
                          sortable: false,
                          center: true,
                          id: "calendario",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                        },
                        {
                          name: "",
                          cell: (row) => (
                            <Bell
                              color={row.alertas ? "#e35205" : "#7D7784"}
                              onClick={(e) => {
                                handleAlert(row);
                              }}
                            />
                          ),
                          id: "alert",
                          sortable: false,
                          center: true,
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                          width: "40px",
                          compact: true,
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default withRouter(Subclientes);
